import request from '@/utils/request';

const PATH = '/search/log';

export const getHotSearchKeyword = (params: any) => request({
  url: `${PATH}`,
  method: 'get',
  params,
});
